import _axios from '../plugins/axios';
export const OrganisationTypes = {
    state: {
        organisation_types: [],
    },

    getters: {
        getOrganisationTypes(state) {
            return state.organisation_types;
        },
    },

    mutations: {
        setOrganisationTypes(state, data) {
            state.organisation_types = data;
        },
    },

    actions: {
        fetchOrganisationTypes({commit}) {
            _axios.get('/api/v1/organisationTypes').then(response => {
                commit('setOrganisationTypes', response.data);
            });
        },
    }
};